function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
const StatusBadge = _ref => {
  let {
    status,
    categoryTitle
  } = _ref;
  const base = {
    position: 'absolute',
    top: '-6px',
    right: '-6px',
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    border: '2px solid #fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  };
  if (status === 'completed') return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, base), {}, {
      background: '#10B981'
    }),
    "data-testid": "icon-".concat(categoryTitle, "-badge-success")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '10px',
      color: '#fff'
    }
  }, "check"));
  if (status === 'in_progress') return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, base), {}, {
      background: '#F59E0B'
    }),
    "data-testid": "icon-".concat(categoryTitle, "-badge-in_progress")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '10px',
      color: '#fff'
    }
  }, "more_horiz"));
  if (status === 'not_started') return /*#__PURE__*/React.createElement("div", {
    style: _objectSpread(_objectSpread({}, base), {}, {
      background: '#E5E7EB'
    }),
    "data-testid": "icon-".concat(categoryTitle, "-badge-not_started")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      fontSize: '10px',
      color: '#9CA3AF'
    }
  }, "remove"));
  return null;
};
export default StatusBadge;